import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import "./plugins/base";
import { firestorePlugin } from "vuefire";
import Vue2TouchEvents from "vue2-touch-events";
import "./registerServiceWorker";
import firebaseConfig from "@/firebase/firebaseConfig";
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;
Vue.use(firestorePlugin);
Vue.use(Vue2TouchEvents);

Vue.use(VueGtag, {
  config: { id: firebaseConfig.measurementId }
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
